import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=0f75dbe2&scoped=true"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&id=0f75dbe2&prod&scoped=true&lang=css"
import style1 from "./dashboard-page.vue?vue&type=style&index=1&id=0f75dbe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75dbe2",
  null
  
)

export default component.exports